// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
// import { DropdownIcon } from "../../../assets/icons/icons";
// import Select, { components } from "react-select";
// import { useSelectedOption } from "../../../context/media-context/SelectedOptionContext";

// const Dropdown = ({
//   items,
//   shouldNavigate = false,
//   setErrorMessage = () => {},
//   routeToGo,
// }) => {
//   const [dropdownOptions, setDropdownOptions] = useState([]);
//   const { selectedOption, setSelectedOption } = useSelectedOption(); // Ensure both selectedOption and setter are available
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Populate dropdown options when items prop changes
//   useEffect(() => {
//     if (items) {
//       const options = items
//         ?.filter((category) => category.category_name && category.category_id)
//         .map((category) => ({
//           value: `${category.category_id}`,
//           label: category.category_name,
//         }));
//       setDropdownOptions(options);
//     }
//   }, [items]);

//   // Handle item selection
//   const handleSelectItem = (item) => {
//     setErrorMessage((prev) => ({
//       ...prev,
//       dropdownError: "",
//     }));

//     setSelectedOption(item);

//     const isVideoRoute = location.pathname.includes("videos");
//     if (shouldNavigate) {
//       const query = `?category_order=${item.value}${
//         isVideoRoute ? "&is_video=true" : ""
//       }`;
//       navigate(`/faceswap/${routeToGo}${query}`);
//     }
//   };

//   // Sync selected option with query params and handle back navigation
//   useEffect(() => {
//     const categoryOrder = searchParams.get("category_order");
//     const categoryName = searchParams.get("category_name");

//     if (!categoryOrder) {
//       // Reset selectedOption to null if no query params are present
//       setSelectedOption(null);
//     } else if (dropdownOptions.length > 0) {
//       const matchedOption = dropdownOptions.find(
//         (option) =>
//           option.value === categoryOrder || option.label === categoryName,
//       );
//       setSelectedOption(matchedOption || null); // Set matched option or null
//     }
//   }, [searchParams, dropdownOptions, setSelectedOption]);

//   // Custom Dropdown indicator
//   const DropdownIndicator = (props) => (
//     <components.DropdownIndicator {...props}>
//       <DropdownIcon />
//     </components.DropdownIndicator>
//   );

//   return (
//     <Select
//       value={selectedOption} // Ensure selectedOption has the same structure as dropdown options
//       onChange={handleSelectItem}
//       placeholder="Select"
//       options={dropdownOptions}
//       components={{ DropdownIndicator }}
//       styles={{
//         control: (base) => ({
//           ...base,
//           borderRadius: "10px",
//           backgroundColor: "#0075FF1A",
//           border: "none",
//         }),
//         dropdownIndicator: (base) => ({
//           ...base,
//           border: "none !important",
//         }),
//         indicatorSeparator: (base) => ({
//           ...base,
//           display: "none",
//         }),
//         placeholder: (base) => ({
//           ...base,
//           fontFamily: "Outfit",
//           fontSize: "14px",
//           fontWeight: "400",
//           lineHeight: "17.64px",
//           color: "#000000",
//         }),
//         container: (base) => ({
//           ...base,
//           width: "120px",
//           borderRadius: "10px",
//           border: "0px",
//         }),
//         option: (base) => ({
//           ...base,
//           overflow: "hidden",
//         }),
//       }}
//     />
//   );
// };

// export default Dropdown;

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { DropdownIcon } from "../../../assets/icons/icons";
import Select, { components } from "react-select";
import { useSelectedOption } from "../../../context/media-context/SelectedOptionContext";

const Dropdown = ({
  items,
  shouldNavigate = false,
  setErrorMessage = () => {},
  routeToGo,
  value, // external selected value
  onChange, // external onChange handler
  name = "premiumfor", // default name for input
  className = "", // extra classes
}) => {
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const { selectedOption, setSelectedOption } = useSelectedOption();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Convert items to react-select format
  useEffect(() => {
    if (items) {
      const options = items
        .filter((category) => category.category_name && category.category_id)
        .map((category) => ({
          value: category.category_id,
          label: category.category_name,
        }));
      setDropdownOptions(options);
    }
  }, [items]);

  // Handle option selection
  const handleSelectItem = (item) => {
    setErrorMessage((prev) => ({
      ...prev,
      dropdownError: "",
    }));

    if (onChange) {
      // Simulate a standard input event for form compatibility
      const syntheticEvent = {
        target: {
          name,
          value: item.value,
        },
      };
      onChange(syntheticEvent);
    } else {
      setSelectedOption(item);
    }

    if (shouldNavigate) {
      const isVideoRoute = location.pathname.includes("videos");
      const query = `?category_order=${item.value}${
        isVideoRoute ? "&is_video=true" : ""
      }`;
      navigate(`/faceswap/${routeToGo}${query}`);
    }
  };

  // Pre-select value from URL if using context
  useEffect(() => {
    if (!onChange && !value) {
      const categoryOrder = searchParams.get("category_order");
      const categoryName = searchParams.get("category_name");

      if (!categoryOrder) {
        setSelectedOption(null);
      } else if (dropdownOptions.length > 0) {
        const matchedOption = dropdownOptions.find(
          (option) =>
            option.value === categoryOrder || option.label === categoryName,
        );
        setSelectedOption(matchedOption || null);
      }
    }
  }, [searchParams, dropdownOptions, setSelectedOption]);

  // Custom dropdown icon
  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <DropdownIcon />
    </components.DropdownIndicator>
  );

  // Determine selected option
  const selected =
    value !== undefined
      ? dropdownOptions.find((opt) => opt.value === value)
      : selectedOption;

  return (
    <Select
      value={selected}
      onChange={handleSelectItem}
      placeholder="Select"
      options={dropdownOptions}
      components={{ DropdownIndicator }}
      className={className}
      styles={{
        control: (base) => ({
          ...base,
          borderRadius: "10px",
          backgroundColor: "#0075FF1A",
          border: "none",
        }),
        dropdownIndicator: (base) => ({
          ...base,
          border: "none !important",
        }),
        indicatorSeparator: (base) => ({
          ...base,
          display: "none",
        }),
        placeholder: (base) => ({
          ...base,
          fontFamily: "Outfit",
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "17.64px",
          color: "#000000",
        }),
        container: (base) => ({
          ...base,
          width: "225px",
          borderRadius: "10px",
        }),
        option: (base) => ({
          ...base,
          overflow: "hidden",
        }),
      }}
    />
  );
};

export default Dropdown;
